var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.621,
    height: 41.621,
    viewBox: "0 0 41.621 41.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10837",
    "data-name": "Groupe 10837",
    transform: "translate(-41 -40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_184",
    "data-name": "Trac\\xE9 184",
    d: "M135.068,228.13h1.387v1.387h-1.387Z",
    transform: "translate(-82.275 -164.545)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_185",
    "data-name": "Trac\\xE9 185",
    d: "M157.2,228.13h1.387v1.387H157.2Z",
    transform: "translate(-101.628 -164.545)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_186",
    "data-name": "Trac\\xE9 186",
    d: "M179.33,228.13h1.387v1.387H179.33Z",
    transform: "translate(-120.988 -164.545)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_187",
    "data-name": "Trac\\xE9 187",
    d: "M135.068,250.265h1.387v1.387h-1.387Z",
    transform: "translate(-82.275 -183.905)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_188",
    "data-name": "Trac\\xE9 188",
    d: "M157.2,250.265h1.387v1.387H157.2Z",
    transform: "translate(-101.628 -183.905)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_189",
    "data-name": "Trac\\xE9 189",
    d: "M179.33,250.265h1.387v1.387H179.33Z",
    transform: "translate(-120.988 -183.905)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_190",
    "data-name": "Trac\\xE9 190",
    d: "M201.466,250.265h1.387v1.387h-1.387Z",
    transform: "translate(-140.349 -183.905)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_191",
    "data-name": "Trac\\xE9 191",
    d: "M223.6,250.265h1.387v1.387H223.6Z",
    transform: "translate(-159.709 -183.905)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_192",
    "data-name": "Trac\\xE9 192",
    d: "M135.068,272.4h1.387v1.387h-1.387Z",
    transform: "translate(-82.275 -203.265)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_193",
    "data-name": "Trac\\xE9 193",
    d: "M157.2,272.4h1.387v1.387H157.2Z",
    transform: "translate(-101.628 -203.265)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_194",
    "data-name": "Trac\\xE9 194",
    d: "M179.33,272.4h1.387v1.387H179.33Z",
    transform: "translate(-120.988 -203.265)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_195",
    "data-name": "Trac\\xE9 195",
    d: "M201.466,272.4h1.387v1.387h-1.387Z",
    transform: "translate(-140.349 -203.265)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_196",
    "data-name": "Trac\\xE9 196",
    d: "M223.6,272.4h1.387v1.387H223.6Z",
    transform: "translate(-159.709 -203.265)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_197",
    "data-name": "Trac\\xE9 197",
    d: "M135.068,294.528h1.387v1.387h-1.387Z",
    transform: "translate(-82.275 -222.619)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_198",
    "data-name": "Trac\\xE9 198",
    d: "M157.2,294.528h1.387v1.387H157.2Z",
    transform: "translate(-101.628 -222.619)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_199",
    "data-name": "Trac\\xE9 199",
    d: "M179.33,294.528h1.387v1.387H179.33Z",
    transform: "translate(-120.988 -222.619)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_200",
    "data-name": "Trac\\xE9 200",
    d: "M201.466,294.528h1.387v1.387h-1.387Z",
    transform: "translate(-140.349 -222.619)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_201",
    "data-name": "Trac\\xE9 201",
    d: "M223.6,294.528h1.387v1.387H223.6Z",
    transform: "translate(-159.709 -222.619)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_202",
    "data-name": "Trac\\xE9 202",
    d: "M135.068,316.663h1.387v1.387h-1.387Z",
    transform: "translate(-82.275 -241.979)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_203",
    "data-name": "Trac\\xE9 203",
    d: "M157.2,316.663h1.387v1.387H157.2Z",
    transform: "translate(-101.628 -241.979)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_204",
    "data-name": "Trac\\xE9 204",
    d: "M179.33,316.663h1.387v1.387H179.33Z",
    transform: "translate(-120.988 -241.979)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_205",
    "data-name": "Trac\\xE9 205",
    d: "M201.466,316.663h1.387v1.387h-1.387Z",
    transform: "translate(-140.349 -241.979)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_206",
    "data-name": "Trac\\xE9 206",
    d: "M223.6,316.663h1.387v1.387H223.6Z",
    transform: "translate(-159.709 -241.979)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_207",
    "data-name": "Trac\\xE9 207",
    d: "M135.068,338.8h1.387v1.387h-1.387Z",
    transform: "translate(-82.275 -261.339)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_208",
    "data-name": "Trac\\xE9 208",
    d: "M157.2,338.8h1.387v1.387H157.2Z",
    transform: "translate(-101.628 -261.339)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_209",
    "data-name": "Trac\\xE9 209",
    d: "M179.33,338.8h1.387v1.387H179.33Z",
    transform: "translate(-120.988 -261.339)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_210",
    "data-name": "Trac\\xE9 210",
    d: "M201.466,338.8h1.387v1.387h-1.387Z",
    transform: "translate(-140.349 -261.339)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_211",
    "data-name": "Trac\\xE9 211",
    d: "M223.6,338.8h1.387v1.387H223.6Z",
    transform: "translate(-159.709 -261.339)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_212",
    "data-name": "Trac\\xE9 212",
    d: "M41,361v1.379H82.621V361Z",
    transform: "translate(0 -280.758)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_213",
    "data-name": "Trac\\xE9 213",
    d: "M81.926,42.081H77.071V40.695A.693.693,0,0,0,76.378,40H69.44a.694.694,0,0,0-.693.695v1.387H41.693a.694.694,0,0,0-.693.695v2.773a.694.694,0,0,0,.693.695h2.081v13.18a.694.694,0,0,0,.695.695.694.694,0,1,1-.695.693H42.386a2.07,2.07,0,0,0,.532,1.375l-1.779,2.371.009.008a.674.674,0,0,0-.148.409v2.776a.7.7,0,0,0,.2.49l1.388,1.387a.688.688,0,0,0,.49.2h2.778a.688.688,0,0,0,.49-.2l1.388-1.387a.7.7,0,0,0,.2-.49V64.973a.674.674,0,0,0-.148-.409l.009-.008-1.775-2.372a2.07,2.07,0,0,0-.856-3.337v-12.6H68.747v.693a.694.694,0,0,0,.693.695h1.388v32.6h-.005l0,.011h1.4l0-.009h-.008V78.36l1.247,1.873h0l.008.009h1.523l0-.009H74.99v-32.6h1.387a.694.694,0,0,0,.695-.695v-.693h4.855a.694.694,0,0,0,.695-.695V42.776A.694.694,0,0,0,81.926,42.081Zm-39.54,2.774V43.468h.486l2.081,1.388Zm4.162,20.811V67.46l-.98.98h-2.2l-.982-.98V65.666Zm-3.468-1.387,1.041-1.388h.693l1.041,1.388Zm4.162-19.562-1.873-1.25h3.746Zm2.289.138,1.873-1.249,1.873,1.249Zm6.035-.138-1.874-1.25H57.44Zm2.288.138,1.873-1.249L61.6,44.855Zm6.036-.138-1.874-1.25h3.746Zm4.857.138H66.181l2.081-1.387h.486Zm1.39-3.469h2.776v2.776H70.135Zm2.074,32.394V70.035l1.249,1.873ZM73.6,77.944l-1.249-1.873L73.6,74.2Zm0-8.329-1.249-1.869,1.249-1.87Zm-1.388-4.156V61.713l1.249,1.873ZM73.6,61.3l-1.249-1.873L73.6,57.55Zm-1.388-4.162V53.388l1.249,1.873ZM73.6,52.971,72.355,51.1,73.6,49.226Zm-1.384-4.162V47.631H73Zm-2.081-2.566V45.55H73.6a.693.693,0,0,0,.693-.692V41.387h1.388l0,4.857Zm6.936-1.526v-1.25h1.878Zm4.161.138H79.359l1.873-1.247Z",
    fill: "#329aec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_214",
    "data-name": "Trac\\xE9 214",
    d: "M324.043,317.319h-.009a3.475,3.475,0,1,0-4.857-4.952,2.085,2.085,0,0,0,0,1.565,2.06,2.06,0,0,0-1,3.383l.015.013h5.842Zm-4.323-.693a.695.695,0,0,1,0-1.389h0a.695.695,0,1,1,0,1.389Zm1.387-2.776a.694.694,0,1,1,.695-.695A.694.694,0,0,1,321.107,313.85Zm1.388,2.774a.694.694,0,1,1,.693-.695A.694.694,0,0,1,322.495,316.625Z",
    transform: "translate(-241.955 -237.085)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_215",
    "data-name": "Trac\\xE9 215",
    d: "M51.8,336.737H51.8l-3.266-3.264a.693.693,0,0,0-.979,0,0,0,0,0,0,0,0l-3.259,3.257c0,.005,0,.011,0,.016h1.945a.571.571,0,0,1,.053-.051l1.751-1.751,1.794,1.794h0l.01.009H51.8Z",
    transform: "translate(-2.879 -256.503)",
    fill: "#252551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_216",
    "data-name": "Trac\\xE9 216",
    d: "M129.578,115.4v2.774h-4.166v-1.387H124.03v1.387h-4.162v-.693H118.48v.693h-4.162v-2.081h9.017v-1.387h-9.017V111.93H112.93v31.2l.01.024h1.383l0-.009h-.009V122.1h4.162v2.341a.693.693,0,0,0,.693.695h2.49l2.574,2.545a.694.694,0,0,0,.486.2h4.857v15.262h-.009l0,.009h1.387c0-.009,0-.018.006-.027V115.4Zm-11.1,5.313h-4.163v-1.151h4.163Zm5.549,4.814-1.6-1.576a.7.7,0,0,0-.486-.2h-2.076v-4.188h4.162Zm5.55.972h-4.167v-6.936h4.167Z",
    transform: "translate(-62.913 -62.913)",
    fill: "#252551"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruct);
export default __webpack_public_path__ + "static/media/construct.4db38390e8220bf76e8b5f81e706ae66.svg";
export { ForwardRef as ReactComponent };